// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q3NW","colBig":"styles_colBig__1j1wp","colSmall":"styles_colSmall__2qB6_","shopifyNameWrapper":"styles_shopifyNameWrapper__2z7le"};